import { Component, Input } from '@angular/core';
import { LovableSuggestedUser } from './lovable-dashboard.models';

@Component({
    selector: 'app-lovable-who-to-follow-panel',
    templateUrl: './lovable-who-to-follow-panel.component.html',
    styleUrls: ['./lovable-who-to-follow-panel.component.css'],
})
export class LovableWhoToFollowPanelComponent {
    @Input() users: LovableSuggestedUser[] = [];
}
